export default {"src":"/_next/static/media/npsScore.26c83ca4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};